import {Component, Vue} from 'vue-property-decorator'

@Component
class IsFromMy extends Vue {
    isFromMy = false;

    //@todo common scheme
    setIsFromMy() {
        this.isFromMy = Object.prototype.hasOwnProperty.call(this.$route.meta?.from.query, 'my');
    }

    getHomeQueryParams() {
        let query = {};
        if (this.isFromMy) {
            query = {my: ''}
        }
        return query;
    }
}

export {IsFromMy}
